// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1325":"ffd0888e","1910":"4c3836e4","4286":"ffd0888e","7219":"c998824d"}[chunkId] + ".chunk.css";
};